import * as React from 'react';

const MastercardPaymentRebrandingSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g id="logo-payment-mastercard-rebranding">
            <path
                id="fill"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 4C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H3ZM11.9997 8.11357C12.8404 7.45202 13.901 7.05737 15.0537 7.05737C17.7835 7.05737 19.9964 9.27028 19.9964 12C19.9964 14.7298 17.7835 16.9427 15.0537 16.9427C13.901 16.9427 12.8404 16.548 11.9997 15.8865C11.159 16.548 10.0984 16.9427 8.94558 16.9427C6.21583 16.9427 4.00293 14.7298 4.00293 12C4.00293 9.27028 6.21583 7.05737 8.94558 7.05737C10.0984 7.05737 11.159 7.45202 11.9997 8.11357Z"
                fill="#161719"
            />
            <path
                id="fill_2"
                opacity="0.3"
                d="M11.9999 15.8864C13.15 14.9814 13.8885 13.577 13.8885 12C13.8885 10.423 13.15 9.01852 11.9999 8.11353C10.8499 9.01852 10.1113 10.423 10.1113 12C10.1113 13.577 10.8499 14.9814 11.9999 15.8864Z"
                fill="#161719"
            />
        </g>
    </svg>
);

MastercardPaymentRebrandingSvg.displayName = 'MastercardPaymentRebrandingSvg';
export default MastercardPaymentRebrandingSvg;
